<template>
  <div>
      <h2 style="border-bottom: 1px solid #CCC; margin-bottom: 25px;">Помощь в работе с системой</h2>
      <BrowserNotifications></BrowserNotifications>
  </div>
</template>

<script>

  import BrowserNotifications from "../components/help/BrowserNotifications.vue";

  export default {
      components: {
        BrowserNotifications
      },
  }

</script>
